import { render, staticRenderFns } from "./CultureMapDetail.vue?vue&type=template&id=0f544c1d"
import script from "./CultureMapDetail.vue?vue&type=script&lang=js"
export * from "./CultureMapDetail.vue?vue&type=script&lang=js"
import style0 from "./CultureMapDetail.vue?vue&type=style&index=0&id=0f544c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports